import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import {Box, CircularProgress, colors, Grid, Typography} from "@material-ui/core";

import { PageTitle } from "../../components/page-title/PageTitle";
import useStyles from "./ICIPAdminSettingsScreen.style";
import { Header } from "../icip_admin_screen/components/Header";
import { ChangePassword } from "./components/ChangePassword";
import ExpandedContent from "../icip_admin_screen/components/ExpandedContent";
import SettingsItem from "../icip_admin_screen/components/SettingsItem";
import {InputField} from "../../components/input-field/InputField";
import {InputButton} from "../../components/input-button/InputButton";
import {OutlineButton} from "../icip_admin_screen/components/Buttons";
import {CustomSwitch, SwitchLanguageWrapper} from "../public/PublicRaffleDrawWinners";

export interface ICIPAdminSettingsScreenProps {}

export const ICIPAdminSettingsScreen = (
  props: ICIPAdminSettingsScreenProps
) => {
  const classes = useStyles(props);
  const intl = useIntl();

  return (
    <>
      <PageTitle
        title={intl.formatMessage({ id: "sharedScreen.adminSettings" })}
      />
      <Box className={classes.root}>
        <Header />
        <Box component="div" pt={6}>
          <Box component="div" className={classes.header}>
            <Typography variant="h3" component="h3">
              <FormattedMessage id="sharedScreen.adminSettings" />
            </Typography>
          </Box>
            <Grid container>
                <Grid item sm={3}>
                    <Box component="div">
                        <SettingsItem
                            title={intl.formatMessage({ id: "sharedScreen.language" })}
                            subTitle=""
                        />
                    </Box>
                </Grid>
                <Grid item sm={4}>
                    <SwitchLanguageWrapper />
                </Grid>
            </Grid>
          <ChangePassword />
        </Box>
      </Box>
    </>
  );
};

ICIPAdminSettingsScreen.routeName = "/admin/settings";
